import React, { useMemo, useState } from "react";

import placeholderImage from "../../assets/images/defaultCover/defaultCoverProduct.png";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  placeholderSrc?: string;
  container?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
}

const Image: React.FC<ImageProps> = ({
  src,
  alt,
  style,
  onLoad,
  placeholderSrc,
  container,
  ...imageProps
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const ImageStyle = useMemo(() => {
    const theStyle = { ...style };
    if (isLoading) {
      theStyle.display = "none";
    }
    return theStyle;
  }, [style, isLoading]);

  return (
    <div {...container}>
      {isLoading && (
        <img
          src={placeholderSrc || placeholderImage}
          alt="Loading..."
          style={style}
          {...imageProps}
        />
      )}
      <img
        src={src}
        alt={alt}
        style={ImageStyle}
        onLoad={(event) => {
          setIsLoading(false);
          onLoad?.(event);
        }}
        {...imageProps}
      />
    </div>
  );
};

export default Image;
